import React from 'react';
import './style.less';
import { Row, Col } from 'antd';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import { OverPack } from 'rc-scroll-anim';
class MobileAircraftInfo extends React.PureComponent {
    componentDidMount() {

    }

    render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    const arr = [1,2,3,4,5,6];
    delete props.dataSource;
    delete props.isMobile;
      const style = { background: '#0092ff', padding: '8px 0' };
      const colStyle = {marginBottom:48}
      return (
      <div className='mobile-aircraft-info-wrapper'>


              <div className="mobile-description">
                  <video src="http://qiniu.metridynamic.com/video/new%20video/payload/20220411-143637.mp4" autoPlay muted loop>

                  </video>
              </div>
                  <div className="description-container">
                      {/* <div className="mobile-description">
                          <h3>力动几何P系列纯电动无人机</h3>
                      </div> */}

                      <div className="mobile-description">
                          <h3>所思所想，如虎添翼  </h3>
                      </div>

                      <div className="mobile-description">
                      <div className='p'>力动几何作为空气动力学技术和尖端工业设计的先驱，一直致力于制造具有大容量、长续航的优质多功能的垂直起降电动无人机，我们的产品现已成为许多个人及工业客户的首选。 </div>
                      </div>

                      <div className="mobile-description">
                         <div className='line'>
                             <Row>
                                 <Col style={colStyle} xs={12} sm={12} md={8} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image%2Fp4%2FPayload%20interchangable.png" alt={""}/>
                                  <p>多载荷互换</p>
                                 </Col>
                                 <Col style={colStyle} xs={12} sm={12} md={8} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image%2Fp4%2FAll%20electric.png" alt={""}/>
                                  <p>纯电动</p>
                                 </Col>
                                 <Col style={colStyle} xs={12} sm={12} md={8} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/level.png" alt={""}/>
                                  <p>6级抗风性能</p>
                                 </Col>
                                 <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/distance.png" alt={""}/>
                                  <p>150km最大控制距离</p>
                                 </Col>
                                 <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/max.png" alt={""}/>
                                  <p>6kg最大载荷</p>
                                 </Col>
                                 <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                                     <img src="http://qiniu.metridynamic.com/image/new-official-en/P4icon/weight.png" alt={""}/>
                                  <p>15kg级最大起飞重量</p>
                                 </Col>
                             </Row>
                         </div>
                      </div>
                  </div>
      </div>
    );
  }
}

export default MobileAircraftInfo;
